module.exports = __webpack_public_path__ + "static/media/Asset6APZ2.359c17d2.png";